/**
 * Reduce rich question content (inline HTML: <strong>, <em>, <a>, …) to plain
 * text for surfaces that can't render markup — emails, CSV exports, table
 * headers, truncated labels. Also decodes the handful of entities the rich
 * text editor produces when escaping user text.
 */
export const stripHtmlTags = (content: string | null | undefined): string => {
  if (!content) return ''

  return content
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .trim()
}
